import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Input from '../Input/Input'
import Style from './AddNote.module.css'
const AddNote = (props) => {
    const[Note,setNote]=useState()
    useEffect(() => {
        setNote(props.userNote)
    }, [props.userNote])
    
    const {register , handleSubmit }=useForm()
    const onSubmitHandler=(data)=>{}
    
    return (
        <div className={Style.NoteHolder}>
            <p><span>*</span>توضيحاتی برای سفارش</p>
            <form  onSubmit={handleSubmit(onSubmitHandler)} className={Style.NoteTextAreaHolder}>
            <Input {...register('note',{required:false})} inputtype='Note' type='textare' placeholder={'مثال: قارچ در ساندويج برگر مخصوص نريزيد'} value={Note===null?"":Note} onChange={e=>props.Textfunction(e.target.value)}/>
            </form>
        </div>
    )
}

export default AddNote
